export default __webpack_public_path__ + "static/media/Refined Elixir of Guile.2edb544b.jpg";